// extracted by mini-css-extract-plugin
module.exports = {"switch_label":"switch_label","switch_box":"switch_box","switch_box_right_label":"switch_box_right_label","switch":"switch","slider":"slider","round":"round"};